module.exports = __webpack_public_path__ + "img/img_guihuazhong.8ce24f85.png";